module.exports = __webpack_public_path__ + "static/meme-48853880982de0780adb04eed6ca73fa.jpg";